function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pencil",
  transform: "translate(0.507 0.689)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1265",
  "data-name": "Group 1265",
  transform: "translate(0 0.024)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1261",
  "data-name": "Group 1261"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_764",
  "data-name": "Path 764",
  d: "M.521,25a.52.52,0,0,1-.5-.664L2.1,17.043a.505.505,0,0,1,.132-.225L18.292.761a2.667,2.667,0,0,1,3.682,0l2.262,2.261a2.607,2.607,0,0,1,0,3.684L8.181,22.763a.521.521,0,0,1-.225.132L.665,24.979A.526.526,0,0,1,.521,25Zm2.547-7.539-1.79,6.26,6.261-1.789L23.5,5.97a1.565,1.565,0,0,0,0-2.21L21.238,1.5h0a1.6,1.6,0,0,0-2.209,0Zm4.745,4.935h0Z",
  transform: "translate(0 -0.024)",
  fill: "#48b05e",
  stroke: "#48b05e",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1262",
  "data-name": "Group 1262",
  transform: "translate(2.085)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_765",
  "data-name": "Path 765",
  d: "M7.729,22.915a.52.52,0,0,1-.369-.889L23.417,5.97a1.565,1.565,0,0,0,0-2.21L21.155,1.5a1.6,1.6,0,0,0-2.209,0L2.89,17.555a.521.521,0,0,1-.736-.736L18.209.761a2.667,2.667,0,0,1,3.682,0l2.262,2.261a2.607,2.607,0,0,1,0,3.683L8.1,22.763A.523.523,0,0,1,7.729,22.915Z",
  transform: "translate(-2.001 -0.024)",
  fill: "#48b05e",
  stroke: "#48b05e",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1263",
  "data-name": "Group 1263",
  transform: "translate(2.083 16.642)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_766",
  "data-name": "Path 766",
  d: "M7.729,22.25A.523.523,0,0,1,7.36,22.1L2.152,16.89a.521.521,0,0,1,.736-.736L8.1,21.361a.52.52,0,0,1-.368.889Z",
  transform: "translate(-2 -16.001)",
  fill: "#48b05e",
  stroke: "#48b05e",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1264",
  "data-name": "Group 1264",
  transform: "translate(6.25 3.101)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_767",
  "data-name": "Path 767",
  d: "M6.521,18.625a.52.52,0,0,1-.369-.889L20.735,3.153a.521.521,0,1,1,.736.736L6.889,18.473A.519.519,0,0,1,6.521,18.625Z",
  transform: "translate(-6 -3.001)",
  fill: "#48b05e"
}))));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.007,
    height: 26.187,
    viewBox: "0 0 26.007 26.187",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.d1c0c3ca.svg";
export { ForwardRef as ReactComponent };